import React from 'react'

export default function PartMap(props) {
    let part = props.part;

    let contacts = part['contacts'];

    let addresses_short = contacts.map(contact => {
        let address = contact['address'];
        let address_short = {};
        address_short['name'] = contact['name'];
        address_short['is_default'] = contact['is_default'];
        address_short['address'] = address['address'];
        address_short['city'] = address['city'];
        address_short['region'] = address['region'];
        address_short['phone'] = contact['phone'];
        address_short['latitude'] = address['latitude'];
        address_short['zipcode'] = address['zip_code'];
        address_short['longitude'] = address['longitude'];
        address_short['email'] = contact['email'];

        return address_short;
    })
    let addresses_json = JSON.stringify(addresses_short);

    return (
        <div class="flex column">
            {
                part['content'] && 
                    <div class="text-block">
                        <div class="text" dangerouslySetInnerHTML={{__html: part['content']}}></div>
                    </div>
            }
            <div 
                id="map-canvas" 
                class="map-multi block item" 
                data-entities={addresses_json} 
                data-zoom={part['zoom']}
                data-disableui={part['disable_ui']}
                data-style={part['style']}
            ></div>
        </div>

    )
}
